import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'frmg-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss'],
  imports: [MatButton]
})
export class ServiceUnavailableComponent {
  constructor(private router: Router) {}

  goHome(): void {
    this.router.navigate(['home']);
  }
}
